module.exports = __webpack_public_path__ + "img/compu-meeting-coordination.82482ea5.svg";